import { useBlockProps } from "@wordpress/block-editor";

export default function save() {
  const blockProps = useBlockProps.save();
  return (
    <div {...blockProps}>
      <em>Dynamic ACF content will render here.</em>
    </div>
  );
}
